import { render } from "./ConfirmAccount.vue?vue&type=template&id=9719a7ee&scoped=true&ts=true"
import script from "./ConfirmAccount.vue?vue&type=script&lang=ts"
export * from "./ConfirmAccount.vue?vue&type=script&lang=ts"

import "./ConfirmAccount.vue?vue&type=style&index=0&id=9719a7ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9719a7ee"]])

export default __exports__